import { MousePointerClick } from 'lucide-react'
import { Button } from '../common'
import styles from './SurfacePreviewCanvas.module.css'

/** The canvas toolbar's "Edit elements" toggle (see usePreviewInspect). */
export function PreviewInspectToggle({ inspectMode, onToggle }) {
  return (
    <Button
      className={styles.inspectToggle}
      variant={inspectMode ? 'primary' : 'secondary'}
      size="sm"
      aria-pressed={inspectMode}
      onClick={onToggle}
      data-testid="preview-edit-elements-toggle"
    >
      <MousePointerClick size={14} aria-hidden="true" />
      Edit elements
    </Button>
  )
}

/**
 * The strip under the canvas toolbar: `idleText` while edit mode is off,
 * otherwise what a click in the preview resolved to, and a locate miss
 * whatever the mode.
 */
export function PreviewInspectStatus({ inspectMode, inspectStatus, flashMiss, idleText }) {
  return (
    <div
      className={styles.inspectStatus}
      data-active={inspectMode || flashMiss}
      role="status"
      data-testid="preview-inspect-status"
    >
      {flashMiss
        ? 'Not visible in this preview layout'
        : !inspectMode
          ? idleText
          : inspectStatus?.kind === 'none'
            ? 'No editable style for this element'
            : inspectStatus?.kind === 'selected'
              ? `Editing: ${inspectStatus.label}`
              : 'Click an element in the preview to edit its style'}
    </div>
  )
}
